interface TextViewHtmlProps {
  text: string
}

export function TextViewHtml({ text }: TextViewHtmlProps) {
  return (
    <div
      className="text-view-html"
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  )
}
